import { storeWithModal } from '../../Agreement/Provider/storeStates';
import create from 'zustand';

const key = 'workflowId';

export const useWorkflowStore = create(set => ({
    ...storeWithModal(set, key)
}));
